const host = process.env.VUE_APP_OSS_URL
const BASE_URL = `${host}/audio/spell/`

function getSoundEffectUrl (code) {
  return BASE_URL + `${code}.mp3`
}

export {
  getSoundEffectUrl
}
